module.exports = __webpack_public_path__ + "static/img/content.f00363d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content.svg
// module id = 1447
// module chunks = 180